import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

export const useValidityStatus = ({
  id,
  gid,
  type,
  defaultValue,
}: {
  defaultValue?: boolean;
  gid?: string;
  id: number;
  type: string;
}) => {
  const { currentNetworkId } = useDefaultAppContexts();

  // We are using the defaultValue to avoid hitting the server when the initial value is already known
  const { data: isValid, isLoading } = useQuery<boolean>({
    queryKey: ['validity_status', type, id || gid],
    enabled: defaultValue === undefined,
    queryFn: () =>
      axios
        .get<{ valid: boolean }>(
          Routes.backoffice_network_validity_path(
            currentNetworkId || 0,
            gid || id,
            {
              type,
            },
          ),
        )
        .then((res) => res.data?.valid),
    staleTime: ms('1m'),
    placeholderData: defaultValue,
  });

  return { isValid, isLoading };
};
